
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { NgModule } from '@angular/core';
import { HttpClientModule, HTTP_INTERCEPTORS } from '@angular/common/http';
import { AuthInterceptor } from 'app/core/auth/auth.interceptor';
import { ConfirmationModule } from './components/confirmation/confirmation.module';
import { ConfirmationService } from './components/confirmation/confirmation.service';
import { CertificateCategoryPipe } from './pipes/certificate-category.pipe';


@NgModule({
    imports: [
        CommonModule,
        FormsModule,
        ReactiveFormsModule,
        HttpClientModule
    ],
    exports: [
        CommonModule,
        FormsModule,
        ReactiveFormsModule,
        HttpClientModule,
        ConfirmationModule,
        CertificateCategoryPipe
    ],
    providers: [
        { provide: HTTP_INTERCEPTORS, useClass: AuthInterceptor, multi: true },
        ConfirmationService,
    ],
    declarations: [
        CertificateCategoryPipe
    ],

})
export class SharedModule {
}
